/* eslint-disable no-undef */
export function showToast(type, message) {
  const containerId = 'qualtrics-status';
  let container = document.getElementById(containerId);
  if (!container) {
    container = document.createElement('div');
    container.id = containerId;
    container.className = 'position-fixed top-0 end-0 p-3';
    container.style.zIndex = 1100;
    document.body.appendChild(container);
  }
  const alert = document.createElement('div');
  const cls = type === 'error' ? 'danger' : type;
  alert.className = `alert alert-${cls} shadow`;
  alert.role = 'alert';
  alert.textContent = message;
  container.appendChild(alert);
  setTimeout(() => { if (alert.parentNode) alert.parentNode.removeChild(alert); }, 5000);
}

window.showToast = showToast;


